import { cn } from "@aircall/ds";

/** Visual validation state shared by the Editable blocks. */
export type EditableValidationStatus = "success" | "error";

const BASE =
  "w-full rounded-md bg-transparent p-1 -m-1 text-foreground outline-none transition-colors placeholder:text-muted-foreground";

const VALIDATION_STATUS: Record<EditableValidationStatus, string> = {
  success:
    "hover:bg-accent focus:ring-2 focus:ring-ring focus-visible:ring-2 focus-visible:ring-ring",
  error:
    "ring-1 ring-destructive bg-destructive/5 hover:ring-destructive focus:ring-2 focus:ring-destructive focus-visible:ring-2 focus-visible:ring-destructive",
};

/**
 * Shared "ghost" inline-edit variants for the Editable blocks: the field looks
 * like plain text until hovered/focused, then reveals an outline. Mirrors the
 * legacy look (transparent surface, ring on interaction, destructive ring for
 * the error state).
 *
 * Expressed as a `cn`-based variants helper (mirroring the sibling `Line` /
 * `UserName` blocks) rather than `cva`, which is not a first-class dependency in
 * this app. The exported helper plays the same role as a `cva` variants object:
 * a single source of truth merged via `cn` at every call site.
 */
export function editableFieldVariants({
  validationStatus = "success",
}: { validationStatus?: EditableValidationStatus } = {}): string {
  return cn(BASE, VALIDATION_STATUS[validationStatus]);
}
